import { render, staticRenderFns } from "./InventorySetting.vue?vue&type=template&id=3dd37cc6"
import script from "./InventorySetting.vue?vue&type=script&lang=js"
export * from "./InventorySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports